import React, {useEffect} from "react";
import { IDialogStatExternalProps, IDialogStatProps} from "./DialogStatsProps";

import "./DialogStats.css";
import { IApplicationState } from "src/~store/models/ApplicationState";
import { connect } from "react-redux";
import { changeSelectedBot, getBots, getMenuDialogStats } from "src/app/analytics/~store/actions/actions";
import { botsSelector, menuDialogStatsSelector, selectedBotIdSelector, selectedCurrentSettingsSelector, selectedSubtabSelector } from "../../../~store/selector";
import { Input } from "reactstrap";
import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { AnalyticTab } from "src/app/analytics/~store/models/enums/AnalyticTab";

type ReduxType = ReturnType<typeof mapStateToProps> & IDialogStatProps;

const DialogStats = (props: ReduxType) => {

    useEffect(() => {
        props.getBots();
    }, []);

    useEffect(() => {
        if(props.selectedBotId) {
            _getStats(props.selectedBotId);
        }
    }, [props.selectedBotId, props.tags])

    const _getStats = (selectedBotId: number) => {
        props.getMenuDialogStats(selectedBotId, props.tags);        
    }

    const _mapBotSwitch = () => {
        return (
            <div className="bot-switch-wrapper">
                <Input
                    type="select"
                    className="bot-switch-select"
                    value={props.selectedBotId}
                    onChange={(e) => {props.changeSelectedBot(+e.currentTarget.value)}}
                    >
                        {props.bots.map(item => (
                            <option key={item.operatorId} value={item.operatorId}>{item.name}</option>
                        ))}
                </Input>
            </div>
        );
    }

    const _mapMenuDialogStats = () => {
        return (
            <div className="menu-dialog-stats-container">
                {props.menuDialogStats.map((item) => (
                    <div key={item.nameDefLocal} className="menu-dialog-stat">
                        <div className="menu-dialog-stat__name">{item.nameDefLocal}</div>
                        <div className="menu-dialog-stat__buttons">{item.buttons.sort((a, b) => b.count - a.count).map((btn, index) => (
                            <div key={btn.buttonClickedDefLocal} className={(index != item.buttons.length -1) ? "menu-dialog-stat__button-name" : ""}>
                                {btn.buttonClickedDefLocal} <strong>[{btn.count}] ({(btn.count / item.buttons.map(b => b.count).reduce((a, b) => a+b) * 100).toFixed(1) + "%"})</strong>
                            </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
      <div className="analytics-tabs-wrapper-container">
        {props.selectedBotId && _mapBotSwitch()}
        {_mapMenuDialogStats()}
      </div>
    );
}

const mapStateToProps = (state: IApplicationState, externalProps: IDialogStatExternalProps) => {
    return {
        menuDialogStats: menuDialogStatsSelector(state),
        bots: botsSelector(state),
        selectedBotId: selectedBotIdSelector(state),
        tags: externalProps.tags,
        currentSettings: selectedCurrentSettingsSelector(state),
    };
}

const mapDispatchToProps = (dispatch: any): IDialogStatProps => {
    return {
        getMenuDialogStats: (selectedBotId: number, tags: ISearchingTag[]) => dispatch(getMenuDialogStats(selectedBotId, tags)),
        getBots: () => dispatch(getBots()),
        changeSelectedBot: (selectedBotId: number) => dispatch(changeSelectedBot(selectedBotId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogStats);